var map = {
	"./克洛塔的末日.jpg": 6028,
	"./国王的陨落.jpg": 326,
	"./救赎花园.jpg": 2770,
	"./最后一愿.jpg": 1127,
	"./梦魇根源.jpg": 8743,
	"./深岩墓室.jpg": 5044,
	"./玻璃拱顶.jpg": 6862,
	"./请选择地图.jpg": 4764,
	"./门徒誓约.jpg": 2857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4091;